import { CricketEvent } from "../../entities/cricket-event";
import { Ground } from "../../entities/ground";
import { Match } from "../../entities/match";
import { Team } from "../../entities/team";
import { BetfairHistoricEvent } from "./betfair-historic-event";

export interface PriceMatchingData {
  eventInfo: EventInfo;
  streamApiEvents: BetfairStreamApiEvent[];
  matchedPrices: Map<string, BetfairHistoricPrice>;
  firstInningsBetfairRunsLineOdds: TranslatedBetfairOdds[];
  firstInningsEreborRunsLineOdds: TranslatedBetfairOdds[];
  firstInningsStartTime: number;
}

export interface EventInfo {
  match: Match;
  ground: Ground;
  events: CricketEvent[];
  team1: Team;
  eventName: string;
  historicEvent: BetfairHistoricEvent;
}

export interface TranslatedBetfairOdds {
  price: number;
  time: number;
}

export interface BetfairHistoricPrice {
  betfairHistoricPriceId: string;
  matchId: string;
  bowlId: string;
  betfairHistoricEventId: string;
  betfairMarketTime: number;
  betfairPrice: number;
}

export interface BetfairStreamApiEvent {
  time: number;
  innings: number;
  over: string;
  type: string;
  value: string;
}

export interface PriceMatchingWebsocketUpdate {
  event: string;
  amountDone: number;
  totalSize: number;
  status: WebsocketStatus;
}

export enum WebsocketStatus {
  ACTIVE = "ACTIVE",
  COMPLETE = "COMPLETE",
}
